export default __webpack_public_path__ + "static/media/aipe.837fa918.png";